import { useLocalStorage } from 'usehooks-ts';

export type DoNotShowAgainType =
  'RemovePatient'
  | 'IsWelcomed'
  | 'IsAITranscribeOnboard'
  | 'isIntroducedPaymentInvoiceFeatures'
  | 'SwitchToAnotherBrand';

export const useDoNotShowAgain = (type: DoNotShowAgainType, userId?: string) => {
  if (type === 'RemovePatient') {
    return useLocalStorage(`doNotShowAgain-${type}`, false);
  }
  return useLocalStorage(`doNotShowAgain-${type}-${userId}`, false);
};
